/**
 * The HubSpot-hosted enquiry form US clusters send demo requests to. The US has no in-app demo
 * form, so its schools landing CTAs link straight out to HubSpot.
 */
export const SCHOOLS_US_DEMO_FORM_URL = 'https://share.hsforms.com/1IKWXuQYUR823j-HyVhr3OQu3gta';
